import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ExitModal, closeModalByName } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { FormPageTitle, ResourcesLoader, redirectTo } from 'omni-package-react-core';
import NewMessageForm from './NewMessageForm';
import { StyledIcon } from './NewMessagePage.styles';
import Constants from '../../Constants';
import NewMessageResource from './NewMessageResource';
import ContractsResource from './NewMessageForm/ContractsResource';
import BusinessLinesResource from './NewMessageForm/BusinessLinesResource';

export interface NewMessagePageProps { }

const NewMessagePage: FC<NewMessagePageProps> = () => {
  const { t } = useTranslation('NewMessagePage');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const messageSource = new URLSearchParams(search).get('messageSource');

  return (
    <ResourcesLoader reloadEveryTime validateAuthorization validateAvailability failIfAnyEssentialInError>
      <ResourcesLoader.Resources>
        <NewMessageResource essential />
        <ContractsResource essential />
        <BusinessLinesResource essential />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <ExitModal
          Icon={StyledIcon}
          name="quitFormModal"
          onCancel={() => { dispatch(closeModalByName('quitFormModal')); }}
          onConfirm={() => redirectTo(`${Constants.BasePagePath}?messageSource=${messageSource}`, navigate)}
        />
        <FormPageTitle data-testid="NewMessagePageMainTitle">{t('title')}</FormPageTitle>
        <NewMessageForm messageSource={messageSource} />
      </ResourcesLoader.Content>
    </ResourcesLoader>
  );
};

export default (NewMessagePage);
